import { useState } from "react";
import { Box,IconButton,Menu,MenuItem,Typography,Avatar,Stack,Tooltip } from "@mui/material";
import { useNavigate } from "react-router-dom";
import MenuOpenRoundedIcon from "@mui/icons-material/MenuOpenRounded";
import MenuRoundedIcon from "@mui/icons-material/MenuRounded";
import KeyboardArrowDownRoundedIcon from "@mui/icons-material/KeyboardArrowDownRounded";
import LogoutRoundedIcon from "@mui/icons-material/LogoutRounded";
import LightModeRoundedIcon from "@mui/icons-material/LightModeRounded";
import DarkModeRoundedIcon from "@mui/icons-material/DarkModeRounded";
import GroupsRoundedIcon from "@mui/icons-material/GroupsRounded";
import userIcon from "../../../static/icons/user.svg";
import { useAuth } from "../../../context/AuthContext";
import { useAppTheme } from "../../../context/ThemeContext";

export default function TopBar({sidebarExpanded,onToggleSidebar,onOpenMobile}){
  const navigate=useNavigate();
  const {user,logout}=useAuth();
  const {isDark,colors,toggleTheme}=useAppTheme();
  const [anchorEl,setAnchorEl]=useState(null);

  const handleLogout=async()=>{
    await logout();
    setAnchorEl(null);
    navigate("/",{replace:true});
  };

  return (
    <Box sx={{height:72,position:"sticky",top:0,zIndex:1100,px:{xs:1.5,sm:2,md:2.5},borderBottom:`1px solid ${colors.border}`,backgroundColor:colors.surface,display:"flex",alignItems:"center",justifyContent:"space-between",gap:1.5}}>
      <Stack direction="row" spacing={1.2} alignItems="center" sx={{minWidth:0}}>
        <Tooltip title={sidebarExpanded?"Contraer menú":"Expandir menú"}>
          <IconButton onClick={onToggleSidebar} sx={{display:{xs:"none",md:"inline-flex"},width:40,height:40,color:colors.text,border:`1px solid ${colors.border}`}}>
            {sidebarExpanded?<MenuOpenRoundedIcon sx={{fontSize:22}} />:<MenuRoundedIcon sx={{fontSize:22}} />}
          </IconButton>
        </Tooltip>

        <IconButton onClick={onOpenMobile} sx={{display:{xs:"inline-flex",md:"none"},width:40,height:40,color:colors.text,border:`1px solid ${colors.border}`}}>
          <MenuRoundedIcon sx={{fontSize:22}} />
        </IconButton>

        <Typography onClick={()=>navigate("/delegado")} sx={{fontSize:{xs:"0.95rem",sm:"1.05rem"},fontWeight:800,color:colors.text,lineHeight:1.2,whiteSpace:"nowrap",cursor:"pointer"}}>
          Panel de control
        </Typography>
      </Stack>

      <Stack direction="row" spacing={1} alignItems="center" sx={{ml:"auto",minWidth:0}}>
        <Tooltip title="Mi equipo">
          <IconButton onClick={()=>navigate("/delegado/equipo")} sx={{width:40,height:40,color:colors.text,border:`1px solid ${colors.border}`,backgroundColor:colors.backgroundSoft,"&:hover":{backgroundColor:colors.surfaceAlt}}}>
            <GroupsRoundedIcon sx={{fontSize:21}} />
          </IconButton>
        </Tooltip>

        <Tooltip title={isDark?"Usar modo claro":"Usar modo oscuro"}>
          <IconButton onClick={toggleTheme} sx={{width:40,height:40,color:colors.text,border:`1px solid ${colors.border}`,backgroundColor:colors.backgroundSoft,"&:hover":{backgroundColor:colors.surfaceAlt}}}>
            {isDark?<LightModeRoundedIcon sx={{fontSize:20}} />:<DarkModeRoundedIcon sx={{fontSize:20}} />}
          </IconButton>
        </Tooltip>

        <Stack direction="row" spacing={1} alignItems="center" onClick={(event)=>setAnchorEl(event.currentTarget)} sx={{px:{xs:0.6,sm:1},py:0.65,borderRadius:"10px",cursor:"pointer",border:`1px solid ${colors.border}`,backgroundColor:colors.backgroundSoft,minWidth:0,"&:hover":{backgroundColor:colors.surfaceAlt}}}>
          <Avatar src={userIcon} sx={{width:34,height:34,bgcolor:"transparent"}} />

          <Box sx={{display:{xs:"none",sm:"block"},minWidth:0}}>
            <Typography sx={{fontSize:"0.86rem",fontWeight:700,color:colors.text,maxWidth:220,overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap",lineHeight:1.2}}>
              {user?.nombre_completo||user?.correo||"Delegado"}
            </Typography>
          </Box>

          <KeyboardArrowDownRoundedIcon sx={{display:{xs:"none",sm:"block"},color:colors.textSecondary,fontSize:20,transform:anchorEl?"rotate(180deg)":"rotate(0deg)",transition:"transform .2s ease"}} />
        </Stack>
      </Stack>

      <Menu anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={()=>setAnchorEl(null)} PaperProps={{elevation:0,sx:{mt:1,minWidth:180,border:`1px solid ${colors.border}`,borderRadius:"10px",backgroundColor:colors.surface}}}>
        <MenuItem onClick={handleLogout} sx={{gap:1,fontSize:"0.88rem",color:colors.text}}>
          <LogoutRoundedIcon sx={{fontSize:19}} />
          Cerrar sesión
        </MenuItem>
      </Menu>
    </Box>
  );
}